import { urls } from "../constants";
import api from "./api";

const getLabs = async ({ doctorId }) => {
  const response = await api.get(
    `${urls.getLabs}${doctorId ? `?doctorId=${doctorId}` : ""}`
  );
  return {
    status: response.status,
    response: response.data,
  };
};

const getProductsFromLab = async ({ LAB_ID, doctorId }) => {
  const response = await api.get(
    `${urls.getProductsFromLab}?laboratoryId=${LAB_ID}&doctorId=${doctorId}`
  );
  return {
    status: response.status,
    response: response.data,
  };
};

const addOrder = async ({ doctorId, products }) => {
  const response = await api.post(urls.addOrder, {
    doctorId,
    products,
  });
  return {
    status: response.status,
    response: response.data,
  };
};

const getLastConsentVersion = async ({ type, owner, target }) => {
  // This one didn't use token in headers in original code, but used 'Content-Type'.
  // api.js attaches token if present. This is likely fine or even better.
  const response = await api.post(urls.getLastConsentVersion, {
    type,
    owner,
    target,
  });
  return {
    status: response.status,
    response: response.data,
  };
};

const getAllProducts = async ({ doctorId }) => {
  const response = await api.get(
    `${urls.getProductsFromLab}?doctorId=${doctorId}`
  );
  return {
    status: response.status,
    response: response.data,
  };
};

const labServices = Object.freeze({
  getAllProducts,
  getLabs,
  getProductsFromLab,
  addOrder,
  getLastConsentVersion,
});

export default labServices;
